import type { LanguageSeed } from "./types";

/** In-memory seed for C0 Languages page — CloudKit seed arrives later. */
export const LANGUAGE_SEEDS: LanguageSeed[] = [
  {
    code: "en",
    name: "English",
    defaultSource: "usccb",
    sortOrder: 10,
    isActive: true,
  },
  {
    code: "tl",
    name: "Filipino (Tagalog)",
    defaultSource: "awitatpapuri",
    sortOrder: 20,
    isActive: true,
  },
];

export function cmsHost(): string {
  return (import.meta.env.VITE_CMS_HOST as string | undefined)?.trim() || "cms.gospelgo.app";
}

export function displayContainerId(): string {
  return (
    (import.meta.env.VITE_CLOUDKIT_CONTAINER_ID as string | undefined)?.trim() ||
    "iCloud.dev.disguised.gospelgo"
  );
}

export function displayEnvironment(): string {
  return (
    (import.meta.env.VITE_CLOUDKIT_ENVIRONMENT as string | undefined)?.trim() || "development"
  );
}
